import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function MagicLink({ setToken }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");
    if (!token) { setError(true); return; }

    fetch(`${process.env.REACT_APP_API_URL}/verify-magic-link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((data) => {
        setToken(data.access_token);
        navigate("/profile");
      })
      .catch(() => setError(true));
  }, []);

  return (
    <div className="login-page">
      <div className="login-container">
        {error ? (
          <>
            <h2 className="login-title">Lien invalide ou expiré</h2>
            <p style={{ textAlign: "center", color: "#666", marginBottom: 20 }}>
              Ce lien a déjà été utilisé ou a expiré (validité 15 min).
            </p>
            <button className="orange-button" onClick={() => navigate("/login")}>
              Retour à la connexion
            </button>
          </>
        ) : (
          <>
            <h2 className="login-title">Connexion en cours…</h2>
            <div className="loader-container">
              <img src="/loader.gif" className="loader" alt="chargement" />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MagicLink;
